import storage from '@fci/business-layer/storage';

storage.init(window.localStorage, window.Configuration);
